import iconUser from 'assets/images/ic-users.svg'
import iconProduct from 'assets/images/ic-sidebar-product.svg'
import iconGeneralSettings from 'assets/images/ic-general-settings.svg'
import iconVoucher from 'assets/images/ic-voucher.svg'
import iconReview from 'assets/images/ic-review.svg'
import iconOrder from 'assets/images/ic-order.svg'
import icFlashSale from 'assets/images/ic-flash-sale.svg'
import icMainPage from 'assets/images/ic-main-page.svg'
import icAnalytics from 'assets/images/ic-analytics.svg'
import iconMoreInfo from 'assets/images/ic-more-info.svg'
import iconLoyaltyProgram from 'assets/images/ic-loyalty-program.svg'

export const MENU = [
    {
        label: 'Product',
        key: 'product',
        icon: iconProduct,
        children: [
            {
                label: 'Product List',
                key: 'product-list',
            },
            {
                label: 'Create Product',
                key: 'create-product',
            },
            {
                label: 'Gift List',
                key: 'gift-list',
            },
            {
                label: 'Create Gift',
                key: 'create-gift',
            },
            {
                label: 'Category',
                key: 'category',
            },
            {
                label: 'Brand List',
                key: 'brand-list',
            },
            {
                label: 'Create Brand',
                key: 'create-brand',
            },
            {
                label: 'Type Product',
                key: 'type-product',
            },
            {
                label: 'Import Product',
                key: 'import-product',
            },
        ],
    },
    {
        label: 'Reviews',
        key: 'review',
        icon: iconReview,
        children: [
            {
                label: 'All Review',
                key: 'all-review',
            },
            {
                label: 'Product Review',
                key: 'product-review',
            },
        ],
    },
    {
        label: 'Order',
        key: 'order',
        icon: iconOrder,
        children: [
            {
                label: 'Order List',
                key: 'order-list',
                id: 5,
            },
            {
                label: 'Request AWB',
                key: 'request-awb',
                id: 5,
            },
            {
                label: 'Surat Jalan',
                key: 'surat-jalan',
                id: 5,
            },
        ],
    },
    {
        label: 'Voucher',
        key: 'voucher',
        icon: iconVoucher,
        children: [
            {
                label: 'Voucher List',
                key: 'voucher-list',
            },
            {
                label: 'Create Voucher',
                key: 'create-voucher',
            },
            {
                label: 'Voucher Generator',
                key: 'voucher-generator',
            },
        ],
    },
    {
        label: 'Analytics',
        key: 'analytic',
        icon: icAnalytics,
        children: [
            {
                label: 'Revenue',
                key: 'revenue',
            },
            {
                label: 'Order',
                key: 'order',
            },
            {
                label: 'Product',
                key: 'product',
            },
            {
                label: 'Customer',
                key: 'customer',
            },
            {
                label: 'Voucher',
                key: 'voucher',
            },
        ],
    },
    {
        label: 'Flash Sale',
        key: 'flash-sale',
        icon: icFlashSale,
        children: [
            {
                label: 'Flash Sale List',
                key: 'flash-sale-list',
            },
            {
                label: 'Create Flash List',
                key: 'create-flash-sale',
            },
        ],
    },
    {
        label: 'Main Page',
        key: 'main-page',
        icon: icMainPage,
        children: [
            {
                label: 'Home Page',
                key: 'home-page',
            },
            {
                label: 'Sale Page',
                key: 'sale-page',
            },
            {
                label: 'About Us',
                key: 'about-us',
            },
            {
                label: 'Partnership',
                key: 'partnership',
            },
            {
                label: 'MSBB Store',
                key: 'msbb-store',
            },
        ],
    },
    {
        label: 'More Info',
        key: 'more-info',
        icon: iconMoreInfo,
        children: [
            {
                label: 'Privacy Policy',
                key: 'privacy-policy',
            },
            {
                label: 'Return Policy',
                key: 'return-policy',
            },
            {
                label: 'FAQ',
                key: 'faq',
            },
        ],
    },
    {
        label: 'General Settings',
        key: 'general-setting',
        icon: iconGeneralSettings,
        children: [
            {
                label: 'Special Gift List',
                key: 'special-gift-list',
            },
            {
                label: 'Create Special Gift',
                key: 'create-special-gift',
            },
            {
                label: 'Search Page',
                key: 'search-page',
            },
            {
                label: 'Beauty Profile List',
                key: 'beauty-profile-list',
            },
            {
                label: 'Create Beauty Profile',
                key: 'create-beauty-profile',
            },
            {
                label: 'Header Banner',
                key: 'header-banner',
            },
            {
                label: 'Maintenance Page',
                key: 'maintenance-page',
            },
        ],
    },
    {
        label: 'Loyalty Program',
        key: 'loyalty-program',
        icon: iconLoyaltyProgram,
        children: [
            {
                label: 'Setting Point Collection',
                key: 'setting-point-collection',
            },
            {
                label: 'Benefit Redeem Point',
                key: 'benefit-redeem-point',
            },
            {
                label: 'User Membership',
                key: 'user-membership',
            },
            {
                label: 'Export Point Member',
                key: 'export-point-member',
            },
        ],
    },
    {
        label: 'MSBB Award',
        key: 'awards',
        icon: iconLoyaltyProgram,
        children: [
            {
                label: 'Nomination',
                key: 'nomination',
            },
            {
                label: 'Thank You Page',
                key: 'thank-you',
            },
            {
                label: 'Winners',
                key: 'winners',
            },
            {
                label: 'Voting Awards',
                key: 'voting',
            },
            {
                label: 'Category Voting',
                key: 'category-voting',
            },
            {
                label: 'Product Nomination',
                key: 'product-nomination',
            },
            {
                label: 'Brand Nomination',
                key: 'brand-nomination',
            },
        ],
    },
    {
        label: 'User',
        key: 'user',
        icon: iconUser,
        children: [
            {
                label: 'User List',
                key: 'user-list',
            },
            {
                label: 'Create User',
                key: 'create-user',
            },
            {
                label: 'User Role',
                key: 'user-role',
            },
        ],
    },
]

export const ACTION_TYPE = {
    CREATE: 'CREATE',
    EDIT: 'EDIT',
    DELETE: 'DELETE',
    ADD: 'ADD',
    REDUCE: 'REDUCE',
    COMPLETE: 'COMPLETE',
}

export const SUBMIT_TYPE = {
    PUBLISH: 'PUBLISH',
    DRAFT: 'DRAFT',
}

export const STEPS_IMPORT_PRODUCT = ['Upload XLSX File', 'Column Mapping', 'Import', 'Done']

export const STATUS = {
    PENDING_PAYMENT: 'pending-payment',
    ON_HOLD: 'on-hold',
    PROCESSING: 'processing',
    PACKING: 'packing',
    DELIVERY: 'on-delivery',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
}

export const HOME_PAGE_TAB_LIST = [
    'mini banner',
    'main banner',
    'promo banner',
    'flash sale',
    'special promo',
    'daily deals',
    `best deals`,
    'product by category',
    'best seller',
    'claim product',
    'instagram',
    'SEO',
]
